<template>
    <div>
        <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-if="competition" v-bind:style="{ backgroundImage: competition.heroImage && `url(${competition.heroImage.large })`}">
            <div class="uk-grid uk-margin-xlarge-top" uk-grid>
                <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                    <router-link to="'/competitions'"><label>STUDENT COMPETITIONS</label></router-link>
                    <h1>{{competition.title}}</h1>

                    <p class="uk-text-lead" v-html="competition.summary"></p>

                </div>
            </div>
        </div>

        <CompetitionDates :competition="competition" />

        <div class="uk-section uk-section-medium uk-background-white ">
            <div class="uk-container uk-container-small">
                <div class="content" v-html="competition.content"></div>
            </div>
        </div>

        <!-- <anchored-heading-template></anchored-heading-template> -->
        <div class="uk-background-white competition-quick-links">
            <div class="uk-container uk-container-small uk-text-center">
                <h3><b>Quick Links</b></h3>
            </div>
            <div class="uk-tab" v-if="state.api.subnav && state.api.subnav.length">
                <router-link class="uk-button theme-button uk-button-primary " :to="nav.link" v-for="nav in state.api.subnav.slice(1)">
                    <a>{{nav.title}}</a>
                </router-link>
            </div>
        </div>

        <div class="uk-section uk-section-default uk-background-lightest" v-if="!!sortedFeaturedEntries && sortedFeaturedEntries.length">
            <div class="uk-container">
                <h2><b>{{competition.menuTitle}}</b> {{competition.highlightsLabel}}</h2>

                <div class="uk-flex uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s" uk-grid v-if="sortedFeaturedEntries.length">
                    <div v-for="entry in sortedFeaturedEntries">
                        <EntryCard :entry="entry.node" :noCard="true" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import CompetitionDates from './CompetitionDates.vue'
import EntryCard from '../EntryCard.vue'
import _ from 'lodash'

export default  {
    inject: ['state'],
    props: ['competition'],
    components: {
        CompetitionDates,
        EntryCard
    },
    updated() {
        if(this.competition && this.competition.title) {
            this.state.setMetaTitle(this.competition.title)
        }
    },
    computed: {
        sortedFeaturedEntries() {
            return _.orderBy(this.competition?.featuredEntries?.edges, ['node.year.title', 'node.prize.prize'], ['desc', 'desc'])
        }
    },
}
</script>
